<template>
  <header>
    <router-link to="/">
      <svg version="1.1" id="logo-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 198.6 50.4" style="enable-background:new 0 0 198.6 50.4;" xml:space="preserve">
        <polygon class="a11" points="81.1,0.8 94.7,36 100,49.6 107.3,49.6 87.9,0.8 "/>
        <polygon class="a12" points="69.2,28.3 60.7,49.6 68,49.6 76.1,28.3 "/>
        <polygon class="a21" points="20.4,0.8 34,36 39.3,49.6 46.6,49.6 27.2,0.8 "/>
        <polygon class="a22" points="8.4,28.3 0,49.6 7.2,49.6 15.3,28.3 "/>
        <g>
          <path class="s1" d="M185.8,22.1l-2.6,6.3c0,0,8.4,0,8.4,8c0,4.3-3.3,7.8-10,7.8c-5.3,0-8.7-2.6-10.4-6l-6.5,2.1
            c2.3,5.4,7.7,10.1,17,10.1c10.4,0,16.9-6.9,16.9-14.4C198.4,28.9,193.9,23.9,185.8,22.1"/>
          <path class="s2" d="M176,28.3l2.6-6.3c0,0-8.4,0-8.4-8c0-4.3,3.3-7.8,10-7.8c5.3,0,8.7,2.6,10.4,6l6.5-2.1
            c-2.3-5.4-7.7-10.1-17-10.1c-10.4,0-16.9,6.9-16.9,14.4C163.3,21.5,167.9,26.5,176,28.3"/>
        </g>
      </svg>
    </router-link>
    <div class="headerline"></div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
header {
  z-index: 10;
  position: absolute;
  height: 50px;
  width: 100%;
  a {
    padding-top: 1px;
    height: 25px;
    display: flex;
    position: absolute;
    left: 10%;
    top: 50%;
    transform: translateY(-50%);
    @include sm {
      left: 5%;
    }
  }
  .headerline {
    pointer-events: none;
    position: absolute;
    margin-top: 24px;
    width: 100%;
    height: 3px;
    background-color: black;
    transition: background-color 1.5s ease-in-out;
  }
  #logo-svg {
    height: 100%;
    width: auto;
    path,
    polygon {
      fill: black;
      transition: fill 1.5s ease-in-out;
    }
  }
  &.white {
    .headerline {
      background-color: white;
    }
    #logo-svg {
      path,
      polygon {
        fill: white;
      }
    }
  }
  @include xs {
    a {
      height: 23px;
      padding: 1px;
      padding-top: 2px;
    }
    #logo-svg {
      height: 20px;
    }
  }
}
// =====================================================
// Special for home
// =====================================================
#app.home {
  header {
    transform: translateY(50vh);
    top: -60px;
    a {
      height: 32px;
      padding-top: 0;
    }
    #logo-svg {
      height: 100%;
    }
    .headerline {
      height: 4px;
      margin-top: 23px;
    }
    @include sm {
      a {
        left: 10%;
      }
    }
    @include xs {
      transform: translateY(50vh);
      top: -47px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/HeaderComponent.vue